/// <reference path='../_all.ts' />

module training {
  'use strict';

  
  export class TrainingServiceData {
    constructor(
      public Trainings: Training[],
      public Name: string,
      public EMail: string,
      public Agency: string
    ) {}
  }


  export class Training {
    constructor(
      public Description: string,
      public EMail: string,
      public EndDate: Date,
      public Id: number,
      public IsCanceled: boolean,
      public Language: string,
      public Person: string,
      public Products: Product[],
      public RegClosing: Date,
      public StartDate: Date,
      public TimeSpan: string,
      public TypeDescD: string,
      public TypeDescE: string,
      public TypeNameD: string,
      public TypeNameE: string
      ) { }
  }

  

  export class TrainingFormData {
    constructor(
      public teilnehmer: string,
      public email: string,
      public vertretung: string,
      public einsatzbereich: string,
      public hotel: boolean,
      public hotelFrom: Date,
      public hotelTo: Date,
      public essenswuensche: string,
      public essenswuenscheprosa: string,
      public remark: string,
      public submitDate: Date
      ) { } 
  }

}